import { canUserAccessAML } from "./userAccess";

// utils/nsamlPermissions.js
export async function canAccessAML({
  userRole,
  userPermissions = [],
  userEmail,
}) {
  // Staff → local permissions
  if (userRole === "Staff") {
    return userPermissions.includes("Check ²");
  } else if (userRole === "Advisers") {
    return true;
  } else if (userRole === "Administrators") {
    return await canUserAccessAML(userEmail);
  } else if (userRole === "External") { 
    return await canUserAccessAML(userEmail);
  }

  // Admins → Firestore list
  // if (userRole === "Administrators") {
  //   return await canAdminAccessAML(userEmail);
  // }

  return false;
}
